import React from "react";
import { ErrorState } from "components/states";
import { getApiErrorMessage } from "api";

/** Compact failed-fetch state for a single dashboard card. */
const CardError = ({ title, error, onRetry }) => (
  <ErrorState
    title={title}
    message={getApiErrorMessage(error, "Please try again in a moment.")}
    onRetry={onRetry}
  />
);

export default CardError;
